export default {
  region: 'eu-west-1',
  IdentityPoolId:
    'arn:aws:cognito-idp:eu-west-1:128231991412:userpool/eu-west-1_7Z8xG2G2O',
  UserPoolId: 'eu-west-1_7Z8xG2G2O',
  ClientId: '241j0fjunn6904k2n9bqci8gjj'
}



// WEBPACK FOOTER //
// ./src/cognito/config.js